import React, { FunctionComponent, Fragment } from "react";
import { Theme, makeStyles, Grid, useTheme } from "@material-ui/core";
import lodash from "lodash";
import { useSpring, animated } from "react-spring";

const INDICATOR_SIZE = 10;
const INDICATOR_MARGIN_SPACING = 1;

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    position: "relative",
  },
  indicator: {
    cursor: "pointer",
    backgroundColor: theme.palette.grey[200],
    borderRadius: 90,
    height: INDICATOR_SIZE,
    width: INDICATOR_SIZE,
    margin: theme.spacing(INDICATOR_MARGIN_SPACING),
  },
  activeIndicator: {
    backgroundColor: "red",
    position: "absolute",
    height: INDICATOR_SIZE,
    width: INDICATOR_SIZE,
  },
}));

interface IPageIndicatorProps {
  pages: number;
  activePage: number;
  colorHEX?: string;
  onClickPageIndicator: (page: number) => void;
}

export const PageIndicator: FunctionComponent<IPageIndicatorProps> = (props) => {
  const theme = useTheme();
  const { pages, activePage, colorHEX = theme.palette.primary.main, onClickPageIndicator } = props;
  const classes = useStyles();
  const activeIndicatorProps = useSpring({
    left: (INDICATOR_SIZE + theme.spacing(INDICATOR_MARGIN_SPACING * 2)) * activePage,
  });

  return (
    <Grid container className={classes.container}>
      {lodash.times(pages, (page) => (
        <Fragment key={page}>
          <Grid item>
            <div className={classes.indicator} onClick={() => onClickPageIndicator(page)} />
          </Grid>
        </Fragment>
      ))}
      <animated.div
        className={`${classes.indicator} ${classes.activeIndicator}`}
        style={{
          ...activeIndicatorProps,
          backgroundColor: colorHEX,
        }}
      />
    </Grid>
  );
};
